import axios from 'axios'
import router from '../router/index.js'
import { MessageBox, Notification } from 'element-ui'
import store from '@/store'
// http://localhost:8080
const host = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://bg.chiyekeji.cn/api' // 根据 process.env.NODE_ENV 的值判断当前是什么环境
//const host = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'http://bg.longshengscrews.com/api' // 根据 process.env.NODE_ENV 的值判断当前是什么环境

const service = axios.create({
	 baseURL: host,
	timeout: 90000
})


// 请求拦截器
service.interceptors.request.use(config => {
	const tokenUser = localStorage.getItem('token')
	console.log('tokenuser',tokenUser)
	// 让每个请求携带自定义token
    if(tokenUser) {
        config.headers['Authorization'] = tokenUser
    }else{
		// router.push('/login').catch(err=>{})
		// localStorage.clear()
	}
	return config
}, error => {
	// 错误抛到业务代码
	error.data = {}
	error.data.msg = '服务器异常，请联系管理员'
	return Promise.resolve(error)
})

// 响应拦截器
service.interceptors.response.use((response) => {
	if (response.data.code == '401') {
		console.log('失败拦截',response.data)
		router.push('/login').catch(err=>{})
		localStorage.clear()
	}
	return response
}, error => {
	// 错误抛到业务代码
	error.data = {}
	error.data.msg = '请求超时或服务器异常，请检查网络或联系管理员'
	return Promise.resolve(error)
})


export default service
